<section class="card-payment">
  <div class="form__group">
    <input
      type="text"
      class="form__control"
      id="pan"
      [(ngModel)]="cardNumber"
      placeholder="Card Number"
      appCardFormatting
    />
  </div>

  <div class="row no-margin-b">
    <div class="row-col__md-6">
      <div class="form__group ml-2">
        <input
          type="text"
          class="form__control exp"
          id="expiryDate"
          [(ngModel)]="expiryDate"
          placeholder="Exp(MM/YY)"
          maxlength="5"
          (keyup)="formatExpDate(expiryDate)"
          (keypress)="allowNumericKeys($event)"
        />
      </div>
    </div>
    <div class="row-col__md-6">
      <div class="form__group mr-2">
        <input
          type="password"
          class="form__control cvv"
          id="CVV"
          [(ngModel)]="cvv"
          placeholder="CVV"
          appNumbersOnly
          maxlength="3"
        />
      </div>
    </div>
  </div>
  <div class="form__group">
    <input
      type="password"
      class="form__control"
      id="pin"
      [(ngModel)]="cardPin"
      placeholder="Card PIN"
      autocomplete="off"
      appNumbersOnly
      maxlength="4"
    />
  </div>
  <p style="font-size: 12px; text-align: justify">
    Please note: Your card will be charged and refunded NGN2 to verify it can be
    used for recurring transactions.
  </p>
  <button
    class="btn btn__primary w-100 no-margin-l btn__md"
		[disabled]="!cardNumber || !expiryDate || !cvv || !cardPin"
    (click)="sendData()"
  >
    Submit
  </button>
</section>
